import { render, staticRenderFns } from "./MamFileManager.vue?vue&type=template&id=255439be&scoped=true&"
import script from "./MamFileManager.vue?vue&type=script&lang=js&"
export * from "./MamFileManager.vue?vue&type=script&lang=js&"
import style0 from "./MamFileManager.vue?vue&type=style&index=0&id=255439be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255439be",
  null
  
)

export default component.exports